import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import DevUserSwitcher from '../common/DevUserSwitcher';

const NAV_GROUPS = [
  {
    label: 'Main',
    items: [
      { to: '/dashboard',    label: 'Dashboard',   icon: 'dash',    notStorekeeper: true, permission: 'dashboard_view' },
      { to: '/inventory',    label: 'Inventory',   icon: 'box',     permission: 'inventory_view' },
      { to: '/item-lookup',  label: 'Item Lookup', icon: 'box',     permission: 'item_lookup_view' },
      { to: '/site-history', label: 'Site History', icon: 'history', permission: 'inventory_view' },
      { to: '/asset-history', label: 'Discard History', icon: 'history', permission: 'asset_history_view' },
    ],
  },
  {
    label: 'Operations',
    items: [
      { to: '/requirements',     label: 'Requirements',     icon: 'req',      permissions: ['requirement_creation', 'transfer_approval', 'transfer_request'] },
      { to: '/transfers',        label: 'Transfers',        icon: 'transfer', permissions: ['transfer_request', 'transfer_approval', 'inventory_view'] },
      { to: '/salary-deductions',label: 'Salary Deductions',icon: 'salary',   permission: 'salary_deduction_view' },
    ],
  },
  {
    label: 'Master Data',
    items: [
      { to: '/workers',     label: 'Workers',        icon: 'worker',     permission: 'worker_management' },
      { to: '/subcontractors', label: 'Manage Subcontractors', icon: 'subcontractor', permission: 'manage_subcontractors' },
      { to: '/groups',      label: 'Groups & Sites', icon: 'group',      permission: 'site_group_management' },
      { to: '/safety-kits', label: 'Materials',      icon: 'kit',        permission: 'master_data_management' },
      { to: '/stationery',  label: 'Stationery Items',icon: 'stationery', permission: 'stationery_manage' },
      { to: '/it',          label: 'IT',              icon: 'it',         permission: 'it_manage' },
    ],
  },
  {
    label: 'My Account',
    items: [
      { to: '/profile', label: 'My Profile', icon: 'profile', always: true },
    ],
  },
  {
    label: 'Administration',
    items: [
      { to: '/permission-groups', label: 'Permissions', icon: 'lock',  permission: 'permission_management' },
      { to: '/audit-logs',        label: 'Audit Logs',  icon: 'audit', permission: 'audit_log_view' },
    ],
  },
];

const ICONS = {
  profile: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
      <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd"/>
    </svg>
  ),
  dash: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
      <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"/>
      <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"/>
    </svg>
  ),
  box: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
      <path d="M4 3a2 2 0 100 4h12a2 2 0 100-4H4z"/>
      <path fillRule="evenodd" d="M3 8h14v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm5 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" clipRule="evenodd"/>
    </svg>
  ),
  worker: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
      <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"/>
    </svg>
  ),
  stationery: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
      <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z"/>
      <path fillRule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clipRule="evenodd"/>
    </svg>
  ),
  it: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
      <path fillRule="evenodd" d="M2 5a2 2 0 012-2h12a2 2 0 012 2v7a2 2 0 01-2 2h-4l1 2h1a1 1 0 110 2H6a1 1 0 110-2h1l1-2H4a2 2 0 01-2-2V5zm2 0h12v7H4V5z" clipRule="evenodd"/>
    </svg>
  ),
  salary: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
      <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z"/>
      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clipRule="evenodd"/>
    </svg>
  ),
  bell: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
      <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"/>
    </svg>
  ),
  req: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
      <path fillRule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm2 10a1 1 0 10-2 0v3a1 1 0 102 0v-3zm4-1a1 1 0 011 1v2a1 1 0 11-2 0v-2a1 1 0 011-1zm-2-6a1 1 0 00-1 1v1a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd"/>
    </svg>
  ),
  transfer: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
      <path d="M8 5a1 1 0 100 2h5.586l-1.293 1.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L13.586 5H8zM12 15a1 1 0 100-2H6.414l1.293-1.293a1 1 0 10-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L6.414 15H12z"/>
    </svg>
  ),
  group: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
      <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z" clipRule="evenodd"/>
    </svg>
  ),
  kit: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
      <path d="M11 17a1 1 0 001.447.894l4-2A1 1 0 0017 15V9.236a1 1 0 00-1.447-.894l-4 2a1 1 0 00-.553.894V17zM15.211 6.276a1 1 0 000-1.788l-4.764-2.382a1 1 0 00-.894 0L4.789 4.488a1 1 0 000 1.788l4.764 2.382a1 1 0 00.894 0l4.764-2.382zM4.447 8.342A1 1 0 003 9.236V15a1 1 0 00.553.894l4 2A1 1 0 009 17v-5.764a1 1 0 00-.553-.894l-4-2z"/>
    </svg>
  ),
  users: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
      <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"/>
    </svg>
  ),
  lock: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
      <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd"/>
    </svg>
  ),
  audit: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
      <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd"/>
    </svg>
  ),
  history: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd"/>
    </svg>
  ),
  subcontractor: (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
      <path d="M17.94 6.31a1 1 0 00-.63-.63L12 4l-1.31-1.69a1 1 0 00-1.58 0L7.8 4 2.69 5.68a1 1 0 00-.63.63L1 8v2a1 1 0 001 1h1v6a1 1 0 001 1h12a1 1 0 001-1v-6h1a1 1 0 001-1V8l-1.06-1.69zM10 5.5L11 7H9l1-1.5zM6 15v-4h8v4H6z"/>
    </svg>
  ),
};

export default function Sidebar({ isOpen = false, onClose = () => {} }) {
  const { user, hasPermission, isSiteRestricted: isStorekeeper } = useAuth();

  const isVisible = (item) => {
    if (item.notStorekeeper && isStorekeeper) return false;
    if (item.always) return true;
    // Everything else is permission-driven — hasPermission already bypasses
    // for super_admin, so 'admin' only sees what it's actually been granted.
    if (item.permissions) return item.permissions.some((p) => hasPermission(p));
    return hasPermission(item.permission);
  };

  return (
    <>
      {/* Backdrop — mobile only, closes the drawer on tap outside it */}
      {isOpen && (
        <div className="fixed inset-0 bg-black/40 z-30 md:hidden" onClick={onClose} />
      )}
      <aside
        className={`w-64 h-screen flex flex-col flex-shrink-0 overflow-hidden fixed md:static inset-y-0 left-0 z-40 transform transition-transform duration-200 ease-in-out md:translate-x-0 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
        style={{ background: 'linear-gradient(180deg, #1e1b4b 0%, #2d2a72 60%, #1e1b4b 100%)' }}>

      {/* Logo */}
      <div className="px-5 py-5 border-b border-white/10">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center shadow-lg flex-shrink-0"
               style={{ background: 'linear-gradient(135deg, #f59e0b, #d97706)' }}>
            <svg viewBox="0 0 20 20" fill="white" className="w-5 h-5">
              <path d="M11 17a1 1 0 001.447.894l4-2A1 1 0 0017 15V9.236a1 1 0 00-1.447-.894l-4 2a1 1 0 00-.553.894V17zM15.211 6.276a1 1 0 000-1.788l-4.764-2.382a1 1 0 00-.894 0L4.789 4.488a1 1 0 000 1.788l4.764 2.382a1 1 0 00.894 0l4.764-2.382zM4.447 8.342A1 1 0 003 9.236V15a1 1 0 00.553.894l4 2A1 1 0 009 17v-5.764a1 1 0 00-.553-.894l-4-2z"/>
            </svg>
          </div>
          <div>
            <h2 className="text-sm font-bold text-white leading-tight">MaterialWatch</h2>
            <p className="text-[10px] text-indigo-300 font-medium tracking-wide">MATERIAL WATCH</p>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 px-3 py-4 overflow-y-auto space-y-5">
        {NAV_GROUPS.map((group) => {
          const visible = group.items.filter(isVisible);
          if (visible.length === 0) return null;
          return (
            <div key={group.label}>
              <p className="text-[10px] font-semibold text-indigo-400 uppercase tracking-widest mb-1.5 px-3">
                {group.label}
              </p>
              <div className="space-y-0.5">
                {visible.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.to === '/'}
                    className={({ isActive }) =>
                      `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-150 group relative ${
                        isActive
                          ? 'bg-white/15 text-white shadow-sm'
                          : 'text-indigo-200 hover:bg-white/10 hover:text-white'
                      }`
                    }
                  >
                    {({ isActive }) => (
                      <>
                        {isActive && (
                          <span className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-5 rounded-r-full"
                                style={{ background: '#f59e0b' }} />
                        )}
                        <span className={`transition-colors ${isActive ? 'text-white' : 'text-indigo-300 group-hover:text-white'}`}>
                          {ICONS[item.icon]}
                        </span>
                        <span className="flex-1">{item.label}</span>
                      </>
                    )}
                  </NavLink>
                ))}
              </div>
            </div>
          );
        })}
      </nav>

      <DevUserSwitcher />

      {/* Back to Portal — a real cross-origin link when this is a standalone
          MaterialWatch build (separate subdomain/container); an in-app route
          otherwise, since the combined build has no dedicated portal URL. */}
      <div className="px-3 pb-2 border-t border-white/10 pt-3">
        {process.env.REACT_APP_PORTAL_URL ? (
          <a
            href={process.env.REACT_APP_PORTAL_URL}
            className="flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium text-indigo-300 hover:bg-white/10 hover:text-white transition-colors"
          >
            <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
              <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
            </svg>
            Back to Portal
          </a>
        ) : (
          <NavLink
            to="/"
            className="flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium text-indigo-300 hover:bg-white/10 hover:text-white transition-colors"
          >
            <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
              <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
            </svg>
            Back to Portal
          </NavLink>
        )}
      </div>

      {/* User profile */}
      <div className="px-3 pb-4 pt-2">
        <div className="flex items-center gap-3 px-3 py-2.5 rounded-lg bg-white/8">
          <div className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold text-white shadow-md flex-shrink-0"
               style={{ background: 'linear-gradient(135deg, #6366f1, #8b5cf6)' }}>
            {(user?.fullName || user?.username)?.[0]?.toUpperCase()}
          </div>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-white truncate">{user?.fullName || user?.username}</p>
          </div>
        </div>
      </div>
    </aside>
    </>
  );
}
